import pRetry from 'p-retry';
import { getSafeErrorFields } from '../errors';
import {
  isMemoryOnlyWriteError,
  isWriteFenceStaleError,
} from '../persistenceV2/writeFence';
import { logger } from './lib/logger';

export const simpleRetry = <T>(p: () => Promise<T>): Promise<T> =>
  pRetry(p, {
    onFailedAttempt: (err) => {
      // p-retry runs this even when `shouldRetry` refuses, and a memory-only
      // refusal is the storage-less event the start or the mid-recording arm
      // already reported, repeated once per write.
      if (isMemoryOnlyWriteError(err)) return;
      logger.warn({
        event_type: 'SIMPLE_RETRY_FAILED_ATTEMPT',
        details: {
          ...getSafeErrorFields(err),
          attemptNumber: err.attemptNumber,
          retriesLeft: err.retriesLeft,
        },
      });
    },

    // Retrying a stale write could cross the next hydrate boundary; a
    // memory-only refusal stands for the whole recording, so retrying it only
    // burns the caller's tail budget on a write that can never land.
    shouldRetry: (err) => !isWriteFenceStaleError(err) && !isMemoryOnlyWriteError(err),

    retries: 3,
  });
